import { AnimatePresence } from 'motion/react';

import { Toast } from '@core/components/Toast/components/ToastComponent';
import { useToastStore } from '@core/stores/toastStore';

/**
 * Toast notification system that provides feedback to users through temporary messages.
 * Supports different variants for different types of messages (success, error, etc.),
 * with automatic dismissal, pause on hover, and progress indication.
 *
 * Features:
 * - Multiple variants (default, success, destructive, warning)
 * - Automatic dismissal with visual progress
 * - Pause on hover
 * - Animated entrance/exit
 * - Accessible close button
 * - Dark mode support
 */

/**
 * Provider component that manages the toast notification system.
 * Handles the rendering and removal of toasts in a fixed position.
 */
export default function ToastProvider() {
  const toasts = useToastStore((state) => state.toasts);

  return (
    <div className="fixed right-0 bottom-4 z-100 flex flex-col items-end gap-2">
      <AnimatePresence>
        {toasts.map((toast) => (
          <Toast key={toast.id} {...toast} />
        ))}
      </AnimatePresence>
    </div>
  );
}
